import { useTranslation } from 'react-i18next';
import Button from 'src/components/design-system/Button';

interface ExpandedDescriptionViewProps {
  description: string;
  height: number;
  onClose: () => void;
}

export default function ExpandedDescriptionView({
  description,
  onClose,
}: ExpandedDescriptionViewProps) {
  const { t } = useTranslation();
  return (
    <div className="bg-gray-100 mt-4">
      {/* Content Container - matching image enlargement padding */}
      <div className="flex-1 bg-white p-4 flex flex-col">
        {/* Description Content */}
        <div className="flex-1 text-sm leading-relaxed text-gray-700 whitespace-pre-line">
          {description}
        </div>
        {/* Footer Controls - matching image enlargement exactly */}
        <div className="px-4 py-3 flex items-center flex-shrink-0">
          <div className="flex-grow" />
          <div className="flex-grow flex justify-end">
            <Button color="info" onClick={onClose}>
              {t('Close')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
